'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _CSSTransition = require('react-transition-group/CSSTransition');

var _CSSTransition2 = _interopRequireDefault(_CSSTransition);

var _TransitionGroup = require('react-transition-group/TransitionGroup');

var _TransitionGroup2 = _interopRequireDefault(_TransitionGroup);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var TRANSITION_TIMEOUT = 300;

var Carousel = function (_Component) {
  _inherits(Carousel, _Component);

  function Carousel(props) {
    _classCallCheck(this, Carousel);

    var _this = _possibleConstructorReturn(this, (Carousel.__proto__ || Object.getPrototypeOf(Carousel)).call(this, props));

    _this.onAnimationStart = function () {
      _this.animating = true;
      if (_this.props.onAnimationStart) {
        var _this$props;

        (_this$props = _this.props).onAnimationStart.apply(_this$props, arguments);
      }
    };

    _this.onAnimationEnd = function () {
      _this.animating = false;
      if (_this.forceUpdateAfterAnimation) {
        _this.forceUpdate();
        _this.forceUpdateAfterAnimation = false;
      }
      if (_this.props.onAnimationEnd) {
        var _this$props2;

        (_this$props2 = _this.props).onAnimationEnd.apply(_this$props2, arguments);
      }
    };

    _this.animating = false;
    return _this;
  }

  _createClass(Carousel, [{
    key: 'shouldComponentUpdate',
    value: function shouldComponentUpdate() {
      if (this.animating) {
        this.forceUpdateAfterAnimation = true;
        return false;
      }
      return true;
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          children = _props.children,
          direction = _props.direction;

      var classes = (0, _classnames2.default)('carousel', {
        'carousel--enter-right': direction > 0,
        'carousel--enter-left': direction < 0
      });
      return _react2.default.createElement(
        _TransitionGroup2.default,
        { component: 'ul', className: classes },
        _react2.default.Children.map(children, function (child) {
          return _react2.default.createElement(
            _CSSTransition2.default,
            {
              key: child.key,
              classNames: 'carousel__item--slide',
              timeout: { enter: TRANSITION_TIMEOUT, exit: TRANSITION_TIMEOUT },
              onEnter: _this2.onAnimationStart,
              onEntered: _this2.onAnimationEnd
            },
            _react2.default.createElement(
              'li',
              { className: 'carousel__item' },
              child
            )
          );
        })
      );
    }
  }]);

  return Carousel;
}(_react.Component);

Carousel.propTypes = {
  children: _propTypes2.default.node,
  direction: _propTypes2.default.number,
  onAnimationStart: _propTypes2.default.func,
  onAnimationEnd: _propTypes2.default.func
};
Carousel.defaultProps = {
  direction: 0
};
exports.default = Carousel;